import { render } from "./EventStatisticsBlock.vue?vue&type=template&id=3d3aa22e&scoped=true"
import script from "./EventStatisticsBlock.vue?vue&type=script&lang=js"
export * from "./EventStatisticsBlock.vue?vue&type=script&lang=js"

import "./EventStatisticsBlock.vue?vue&type=style&index=0&id=3d3aa22e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3aa22e"]])

export default __exports__